var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-startPractice" }, [
    _c("div", { staticClass: "leftBox" }, [
      _c("i", {
        staticClass: "iconfont iconfanhui",
        on: {
          click: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c("div", { staticClass: "grade" }, [
        _vm._v(" " + _vm._s(_vm.datas.testScore) + " "),
        _c("span", { staticClass: "f20" }, [_vm._v("分")]),
      ]),
      _c("div", { staticClass: "title f24" }, [
        _vm._v(_vm._s(_vm.datas.paperName)),
      ]),
      _c(
        "div",
        { staticClass: "total-text" },
        [
          _vm._l(_vm.datas.topicTypeMap, function (item, key) {
            return _c("span", { key: key, staticClass: "mar40" }, [
              _vm._v(
                _vm._s(key) +
                  _vm._s(item.questionNumber) +
                  "题 共" +
                  _vm._s(item.questionScore) +
                  "分"
              ),
            ])
          }),
          _c("span", { staticClass: "mar40" }, [
            _vm._v("得分" + _vm._s(_vm.datas.passScore) + "分及格"),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { class: _vm.fontClass },
        [
          _vm.currentQuestion.questionType == "填空题"
            ? _c("FillBlank", {
                attrs: {
                  index: _vm.currentIndex,
                  datas: _vm.currentQuestion,
                  isDisabled: _vm.isDisabled,
                },
              })
            : _vm._e(),
          _vm.currentQuestion.questionType == "单选题"
            ? _c("ChoiceOne", {
                attrs: {
                  index: _vm.currentIndex,
                  datas: _vm.currentQuestion,
                  isDisabled: _vm.isDisabled,
                },
              })
            : _vm._e(),
          _vm.currentQuestion.questionType == "多选题"
            ? _c("ChoiceMultiple", {
                attrs: {
                  index: _vm.currentIndex,
                  datas: _vm.currentQuestion,
                  isDisabled: _vm.isDisabled,
                },
              })
            : _vm._e(),
          _vm.currentQuestion.questionType == "判断题"
            ? _c("Judge", {
                attrs: {
                  index: _vm.currentIndex,
                  datas: _vm.currentQuestion,
                  isDisabled: _vm.isDisabled,
                },
              })
            : _vm._e(),
          !["填空题", "单选题", "多选题", "判断题"].includes(
            _vm.currentQuestion.questionType
          )
            ? _c("Subjective", {
                attrs: {
                  index: _vm.currentIndex,
                  datas: _vm.currentQuestion,
                  isDisabled: _vm.isDisabled,
                },
              })
            : _vm._e(),
          _vm.currentIndex != _vm.datas.topicList.length
            ? _c("div", { staticClass: "submit mat20" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.next(false)
                      },
                    },
                  },
                  [_vm._v("下一题")]
                ),
              ])
            : _vm._e(),
          _c("QuestionAnalysis", {
            attrs: { analysisDatas: _vm.currentQuestion },
            on: { collectChange: _vm.updateCollect },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "mat20" },
      [
        _c("AnswerSheet", {
          attrs: {
            isAnalysis: true,
            currentId: _vm.currentQuestion.id,
            datas: _vm.datas,
          },
          on: { change: _vm.jumpTo, submit: _vm.submit },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }